import * as React from 'react';
import { Tooltip } from '@hotjar/hotsauce';

export const DecoratedTooltip = ({
  children,
  text,
  isBold = false,
  isUnderline = true,
}: {
  children?: React.ReactNode;
  text: string;
  isBold?: boolean;
  isUnderline?: boolean;
}): JSX.Element => {
  let childElement = children;

  if (isUnderline) {
    childElement = <u>{childElement}</u>;
  }

  if (isBold) {
    childElement = <b>{childElement}</b>;
  }

  return (
    <Tooltip text={text}>
      <span>{childElement}</span>
    </Tooltip>
  );
};
